import React from 'react';
import PropTypes from 'prop-types';
import { Input, FormItem } from 'formik-antd';
import { Button, Divider } from 'antd';
import { MinusCircleOutlined } from '@ant-design/icons';
import { DB_PREFIX_REFEREES as DB_PREFIX } from '../constants';
import StagePropTypes from '../prop-types';

import './style.css';

const Row = ({ arrayHelpers, values, setFieldValue, i }) => {
  const prefix = 'referees';

  return (
    <>
      <div className={`${prefix}-input-wrapper`} key={i}>
        <FormItem label="Full name" name={`${DB_PREFIX}.${i}.name`}>
          <Input
            name={`${DB_PREFIX}.${i}.name`}
            placeholder="Full Name"
          />
        </FormItem>

        <FormItem label="Job role" name={`${DB_PREFIX}.${i}.role`}>
          <Input
            name={`${DB_PREFIX}.${i}.role`}
            placeholder="Job Role"
          />
        </FormItem>

        <FormItem label="Organisation" name={`${DB_PREFIX}.${i}.organisation`}>
          <Input
            name={`${DB_PREFIX}.${i}.organisation`}
            placeholder="Organisation"
          />
        </FormItem>

        <FormItem label="Telephone" name={`${DB_PREFIX}.${i}.telephone`}>
          <Input
            name={`${DB_PREFIX}.${i}.telephone`}
            placeholder="Telephone"
          />
        </FormItem>

        <FormItem label="Email" name={`${DB_PREFIX}.${i}.email`}>
          <Input
            name={`${DB_PREFIX}.${i}.email`}
            placeholder="Email"
          />
        </FormItem>

        <Button
          type="danger"
          className="dynamic-delete-button"
          onClick={() => arrayHelpers.remove(i)}
        >
          <MinusCircleOutlined className="dynamic-delete-button" />
        </Button>
      </div>

      <Divider />
    </>
  );
};

Row.propTypes = {
  i: PropTypes.number.isRequired,
  arrayHelpers: PropTypes.shape({
    push: PropTypes.func,
    remove: PropTypes.func,
  }).isRequired,
  setFieldValue: PropTypes.func.isRequired,
  values: StagePropTypes.isRequired,
};

export default Row;
